export default __webpack_public_path__ + "static/media/ic_avalanche_24.be4891c9.svg";